import { environment } from "src/environments/environment";

/**
 * Single source of truth for everything customer-branded in this build.
 *
 * This workspace is the starting point for new customers, so keep brand values
 * HERE and read them from components — never hard-code a name, a phone number
 * or a social URL in a template. Swapping the files under `src/assets/media/`
 * needs no code change: the paths below are stable, only the file contents
 * differ.
 */
export const BRAND = {
  name: "Wise",
  legalName: "Wise Demo",
  tagline: "แพลตฟอร์มเรียนออนไลน์ — เวอร์ชันทดลองใช้",
  description:
    "ทดลองใช้ระบบเรียนออนไลน์ของ Wise ได้ฟรี ดูวิดีโอบทเรียน ทำแบบฝึกหัด " +
    "ดูสถิติการเรียน ข้อมูลทั้งหมดในระบบนี้เป็นข้อมูลตัวอย่างสำหรับสาธิตเท่านั้น",
  logo: "./assets/media/logos/wise-mark.png",
  /**
   * The landing banner.
   *
   * Full-bleed, and deliberately a still life rather than people — type on a
   * photograph needs a wash under it, and a wash over faces turns them into
   * blank shapes, which is worse than having no photograph at all.
   *
   * This frame is chosen for where its subject sits: the left third is bare
   * desk, which is the headline's zone, and the notebook and the hand are right
   * of centre where nothing is set over them.
   */
  heroImage: "./assets/media/landing/banner-hero.webp",
  contact: {
    address: "ตัวอย่างข้อมูลติดต่อ — ระบบสาธิต",
    tel: "02 000 0000",
    email: "demo@example.com",
  },
  /** The demo has no real social presence; an empty list renders nothing rather
   *  than linking somebody else's accounts. */
  socials: [] as { name: string; icon: string; url: string }[],
};

/**
 * Demo-mode switches. Gated on `environment.demo`, which is only true in the
 * demo build configuration, so every one of these compiles out of a customer
 * build.
 */
export const DEMO = {
  enabled: !!(environment as any).demo,

  /** The persistent "this is a demo" ribbon. */
  showBanner: true,

  /**
   * The demo keeps the whole checkout flow visible — it is most of what people
   * come to look at — but there is no payment provider behind it and the seeded
   * bank accounts are fictional, so every payment surface carries a notice.
   */
  paymentIsSimulated: true,

  /**
   * Seeded demo student, used by the one-click login.
   *
   * These must match the account the API seed actually creates — if they drift,
   * the "look around without signing up" button answers 401 to every visitor,
   * which is the one thing on a public demo that must never fail.
   */
  account: {
    username: "demo@wise.demo",
    password: "demo1234",
  },

  /**
   * The seeded parent, for the second one-click login.
   *
   * The 2021 demo offered both roles on its sign-in panel and the reason holds:
   * the parent screens — their child's report, the courses they bought, the
   * seats they hand out — are a third of what there is to look at, and a
   * visitor who has to be told a password to see them does not see them.
   */
  parentAccount: {
    username: "parent@wise.demo",
    password: "demo1234",
  },
};
